import helper from 'store/reducers/reducerHelper';
import initialState from 'store/reducers/initialState';

import {
  SET_IS_SHOW_EDIT_ASSET_FORM,
  SET_ASSET_TO_EDIT,
  SET_IS_SHOW_SUBSCRIPTION_WIDGET,
} from 'store/types/layoutActionTypes';

const layoutReducer = (state = initialState.layout, action) => {
  return helper.handleActions(state, action, {
    [SET_IS_SHOW_EDIT_ASSET_FORM](state, payload) {
      state.assetEdit = {
        ...state.assetEdit,
        isShowEditForm: payload.isShowEditForm,
      };
    },

    [SET_ASSET_TO_EDIT](state, payload) {
      const editAssetPayload = {
        currentAsset: payload.currentAsset,
      };

      if (payload.currentAssetType)
        editAssetPayload['currentAssetType'] = payload.currentAssetType;

      state.assetEdit = {
        ...state.assetEdit,
        ...editAssetPayload,
      };
    },

    [SET_IS_SHOW_SUBSCRIPTION_WIDGET](state, payload) {
      state.isShowSubscriptionWidget = payload.isShowSubscriptionWidget;
    },
  });
};

export default layoutReducer;
